/**
 * Shop Page
 */

export default function HWY_Shop() {
	const selectors = {
		option: ".filter-option",
		container: ".products-container",
		varietal: ".filter-varietal",
		type: ".filter-type",
		vintage: ".filter-vintage",
		loadMore: ".shop-page .load-more button",
		techspecs: "tech-specs",
	};

	const pageSize = 8;

	jQuery.urlParam = function (name) {
		var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
			window.location.search
		);
		return results !== null ? results[1] || 0 : false;
	};

	this.init = () => {
		if (
			window.location.pathname.includes("/shop/") &&
			jQuery.urlParam("slug")
		) {
			const parts = window.location.search.split("=");
			const target = parts.pop() || parts.pop();
			const link = window.location.origin + "/shop?slug=" + target;
			handleFilterAction(jQuery(jQuery(`#${target}`)));
			window.history.pushState(null, "", link);
			// } else if (
			// 	window.location.pathname.includes("/shop/") &&
			// 	window.location.pathname.length > 6
			// ) {
			// 	const parts = window.location.pathname.split("/");
			// 	const target = parts.pop() || parts.pop();
			// 	window.location.href =
			// 		window.location.origin +
			// 		"/shop" +
			// 		(target == "shop" ? "" : `?slug=${target}`);
		}
		window.addEventListener(
			"popstate",
			function (event) {
				const parts = window.location.search.split("=");
				var target = parts.pop() || parts.pop();
				if (!target || typeof target == undefined) {
					target = "all-wine";
				}
				// const link = window.location.origin + "/shop?slug=" + target;
				handleFilterActionBack(jQuery(`#${target}`));
			},
			false
		);

		jQuery(".filter h4").on("click", function () {
			if (jQuery(this).hasClass("opened")) {
				jQuery(this).next().addClass("d-none");
			} else {
				jQuery(this).next().removeClass("d-none");
				if (window.innerWidth < 768) {
					jQuery(this).next().css({ display: "flex" });
				}
			}
			jQuery(this).toggleClass("opened");
		});
		jQuery(".filters > h4").on("click", function () {
			if (jQuery(this).hasClass("opened")) {
				jQuery(this).next().addClass("d-none");
			} else {
				jQuery(this).next().removeClass("d-none");
				jQuery(".filter h4").removeClass("opened");
				jQuery(".filter-options").hide();
				jQuery(this).next().css({ display: "block" });
			}
			jQuery(this).toggleClass("opened");
		});

		jQuery(selectors.option).on("click", function () {
			handleFilterAction(jQuery(this));
		});

		jQuery(selectors.loadMore).on("click", function () {
			const target = jQuery(this)
				.closest(".shop-page")
				.find(".filter-option.active")
				.data("target");
			const hiddenProducts = jQuery(this)
				.closest(".products")
				.find(`.product.d-none.${target}`);
			hiddenProducts.each(function (index) {
				if (index < pageSize) {
					jQuery(this).removeClass("d-none");
				}
			});
			const current = jQuery(this)
				.closest(".products")
				.find(".product:not(.d-none)").length;
			const total = jQuery(this)
				.closest(".products")
				.find(`.product.${target}`).length;
			jQuery(".counts .current").text(current);
			jQuery(".counts .total").text(total);

			if (current == total) jQuery(".load-more").addClass("d-none");
		});
	};

	const handleFilterAction = (element) => {
		const target = element.data("target");
		const title = element.data("title");
		const description = element.data("description");

		jQuery(selectors.option).removeClass("active");
		element.addClass("active");

		jQuery(`.products .product`).addClass("d-none");
		const products = jQuery(`.products .product.${target}`);

		products.each(function (index) {
			if (index < pageSize) {
				jQuery(this).removeClass("d-none");
			}
		});

		const total = products.length;
		const current = jQuery(`.products .product:not(.d-none)`).length;
		element.closest(".shop-page").find(".total").text(total);
		element.closest(".shop-page").find(".current").text(current);
		if (total == current) {
			element.closest(".shop-page").find(".load-more").addClass("d-none");
		} else {
			element
				.closest(".shop-page")
				.find(".load-more")
				.removeClass("d-none");
		}

		element.closest(".shop-page").find(".intro h1").text(title);
		element
			.closest(".shop-page")
			.find(".intro .shop-page-description")
			.html(description);

		const link = window.location.origin + "/shop?slug=" + target;

		window.history.pushState(null, title, link);

		if (window.innerWidth < 768) {
			element
				.closest(".filters")
				.find("> h4.opened")
				.removeClass("opened");
			element.closest(".filters-wrapper").hide();
		}
	};
	const handleFilterActionBack = (element) => {
		const target = element.data("target");
		const title = element.data("title");
		const description = element.data("description");

		jQuery(selectors.option).removeClass("active");
		element.addClass("active");

		jQuery(`.products .product`).addClass("d-none");
		const products = jQuery(`.products .product.${target}`);

		products.each(function (index) {
			if (index < pageSize) {
				jQuery(this).removeClass("d-none");
			}
		});

		const total = products.length;
		const current = jQuery(`.products .product:not(.d-none)`).length;
		element.closest(".shop-page").find(".total").text(total);
		element.closest(".shop-page").find(".current").text(current);
		if (total == current) {
			element.closest(".shop-page").find(".load-more").addClass("d-none");
		} else {
			element
				.closest(".shop-page")
				.find(".load-more")
				.removeClass("d-none");
		}

		element.closest(".shop-page").find(".intro h1").text(title);
		element
			.closest(".shop-page")
			.find(".intro .shop-page-description")
			.html(description);

		// const link = window.location.origin + "/shop?slug=" + target;

		// window.history.pushState(null, title, link);

		if (window.innerWidth < 768) {
			element
				.closest(".filters")
				.find("> h4.opened")
				.removeClass("opened");
			element.closest(".filters-wrapper").hide();
		}
	};
}
